function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState, useEffect, createContext, useContext } from 'react';
import { useAccordion } from './AccordionContext';
export var useGetItem = function useGetItem(value) {
  if (value === void 0) {
    value = '';
  }

  var {
    state
  } = useAccordion();
  var [item, setItem] = useState({
    isOpen: false,
    value: ''
  });
  useEffect(() => {
    if (value) {
      var foundItem = ((state == null ? void 0 : state.items) || []).find(currentItem => currentItem.value === value);

      if (foundItem) {
        setItem(_extends({}, foundItem, {
          state: foundItem.isOpen ? 'open' : 'closed'
        }));
      }
    }
  }, [value, state == null ? void 0 : state.items]);
  return item;
};
var AccordionItemContext = /*#__PURE__*/createContext({});
export var AccordionItemProvider = _ref => {
  var {
    value,
    children
  } = _ref;
  var item = useGetItem(value);
  return /*#__PURE__*/React.createElement(AccordionItemContext.Provider, {
    value: _extends({
      value
    }, item)
  }, children);
};
export var useAccordionItem = () => useContext(AccordionItemContext);
export default _extends({}, AccordionItemContext, {
  Provider: AccordionItemProvider
});
//# sourceMappingURL=AccordionItemContext.js.map